import { cn } from "@/util/cn";
import { Panel } from "../components/Panel";
import { TrackerView } from "../components/TrackerView";
import { bemName } from "../util/bemName";

import "./TrackerPanel.scss";
import PanelCard from "@/components/PanelCard";

const componentName = "TrackerPanel";

interface Props {
  maxEntries?: number;
  center?: boolean;
}

export const TrackerPanel: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <PanelCard title="Tracker">
      <TrackerView maxEvents={props.maxEntries} />
    </PanelCard>
  );
};

export default TrackerPanel;
